<template>
    <div class="home-page info-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li @click="back"><span>{{$t('katakana')}}</span></li>
                <li><span>{{$t('Detail')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/Kanji-Title-Pic.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">ひらがな</div>
                  <div class="jp">{{$t('katakana')}} {{$t('Detail')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grammar-content">
          <div class="grammar-detail">
            <div class="detail_inner" v-if="info.id">
              <div class="m_tabpne">
                <div class="m_tabsbj js_active">
                  <div class="tabsbj_inner">
                    <div class="detail_ordersummary">
                      <div class="detail_summary">
                        <span class="image">
                          <img :src="info.word_image" :alt="getVocabularyText(0, 'vocabulary_zh')">
                        </span>
                        <div class="words">
                          <div class="words_inner">
                            <p>{{ getVocabularyText(0, 'vocabulary_zh') }}<span class="slash">/</span><em>{{ getVocabularyText(0, 'vocabulary_jp') }}</em></p>
                            <i><em class="cr8a570f">{{ getVocabularyText(0, 'vocabulary_yin') }}</em></i>
                            <button
                              @click="toggleVocabularyAudio(0)"
                              :class="{ 'image-grow': activeAudioIndex === 0 }"
                            >
                              <img src="../../static/images/yin2.png" alt="Play audio">
                            </button>
                            <audio
                              preload="auto"
                              :ref="'audioVocabulary0'"
                              @ended="onAudioEnded(0)"
                            >
                              <source :src="getVocabularyAudio(0)" type="audio/mp3">
                            </audio>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- VOCABULARIES 滑动轮播部分 -->
                    <div class="detail_memory">
                      <strong>{{$t('VOCABULARIES')}}</strong>
                      <div class="vocab-carousel">
                        <div class="carousel-container">
                          <!-- 左箭头 -->
                          <button
                            class="carousel-arrow carousel-arrow-prev"
                            @click="prevVocabulary"
                            :disabled="currentVocabularyIndex === 0"
                          >
                            ‹
                          </button>

                          <!-- 滑动轮播内容 -->
                          <div
                            class="carousel-content"
                            ref="carouselContent"
                            @touchstart="onTouchStart"
                            @touchmove="onTouchMove"
                            @touchend="onTouchEnd"
                            @mousedown="onMouseDown"
                            @mousemove="onMouseMove"
                            @mouseup="onMouseUp"
                            @mouseleave="onMouseLeave"
                          >
                            <div
                              class="carousel-track"
                              :style="{
                                transform: `translateX(-${currentVocabularyIndex * 100}%)`,
                                transition: isDragging ? 'none' : 'transform 0.3s ease'
                              }"
                            >
                              <div
                                class="carousel-slide"
                                v-for="(item1, index1) in info.vocabularies"
                                :key="index1"
                              >
                                <div class="vocab-item">
                                  <img :src="item1.vocabulary_image" :alt="item1.vocabulary_jp">
                                  <div class="img-text mt20 al">
                                    <span class="vocab-jp">{{ item1.vocabulary_jp }}</span>
                                    <button
                                      @click="toggleVocabularyAudio(index1 + 1)"
                                      :class="{ 'image-grow': activeAudioIndex === (index1 + 1) }"
                                      class="audio-btn"
                                    >
                                      <img src="../../static/images/yin2.png" width="30" alt="Play audio">
                                    </button>
                                    <audio
                                      preload="auto"
                                      :ref="`audioVocabulary${index1 + 1}`"
                                      @ended="onAudioEnded(index1 + 1)"
                                    >
                                      <source :src="item1.vocabulary_audio" type="audio/mp3">
                                    </audio>
                                    <div class="vocab-yin">
                                      <em class="cr8a570f">{{ item1.vocabulary_yin }}</em>
                                    </div>
                                    <div class="vocab-en">{{ item1.vocabulary_en }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- 右箭头 -->
                          <button
                            class="carousel-arrow carousel-arrow-next"
                            @click="nextVocabulary"
                            :disabled="currentVocabularyIndex === info.vocabularies.length - 1"
                          >
                            ›
                          </button>
                        </div>

                        <!-- 指示器 -->
                        <div class="carousel-indicators" v-if="info.vocabularies && info.vocabularies.length > 1">
                          <span
                            v-for="(item, index) in info.vocabularies"
                            :key="index"
                            class="indicator"
                            :class="{ 'active': index === currentVocabularyIndex }"
                            @click="goToVocabulary(index)"
                          ></span>
                        </div>
                      </div>
                    </div>

                    <div class="detail_anime mt20">
                      <strong>{{$t('ANIMATION')}}</strong>
                      <div class="anime por">
                        <video
                          controls
                          webkit-playsinline
                          playsinline
                          ref="videoPlayer"
                        >
                          <source :src="info.stroke_video" type="video/mp4">
                          <p>To play the video, you need a browser that supports video tags.</p>
                        </video>
                      </div>
                    </div>
                  </div>

                  <div class="detail_order mt30 ac">
                    <div class="image order1">
                      <img :src="info.stroke_image" alt="Stroke order 1">
                    </div>
                  </div>
                </div>
              </div>
              <div class="kanji-ul">
                <ul class="">
                  <li style="padding:10px;margin: 0 10px 10px;"
                    class="kanji-li"
                    v-for="item in info.relate"
                    :key="item.id"
                    :class="{ 'js_active': item.id === info.id }"
                    @click="switchKanji(item.id)"
                  >
                    <img :src="item.word_image" width="70" :alt="'Kanji ' + item.id">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>
    </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import md5 from '../../static/js/md5.min.js'
export default {
    components:{
        Header,Dialog
    },
    data() {
      return {
        info:{},
        id:'',
        startTime: 0,
        totalWatchTime: 0,
        // reportingInterval: null,
        videoElement: null,
        strokeVideoPlaying: false,
        memoryVideoPlaying: false,
        activeAudioIndex: -1,
        currentVocabularyIndex: 0,
        // 滑动相关状态
        isDragging: false,
        startX: 0,
        currentX: 0,
        dragDistance: 0,
        dragThreshold: 50 // 滑动阈值
      }
    },
    mounted() {
      // document.addEventListener('visibilitychange', this.handleVisibilityChange);
      // window.addEventListener('beforeunload', this.handleBeforeUnload);
      this.videoElement = this.$refs.videoPlayer;
    },
    beforeDestroy() {
      // clearInterval(this.reportingInterval);
      // document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      // window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    watch: {
      '$route'(to, from) {
        if (to.query.id !== from.query.id) {
          this.id = to.query.id;
          this.getList();
        }
      },
      'info': {
        handler(newVal) {
          if (newVal.vocabularies) {
            this.currentVocabularyIndex = 0;
          }
        },
        deep: true
      }
    },
    beforeRouteLeave(to, from, next) {
      this.pauseAllVideos();
      this.pauseAllAudios();
      next();
    },
    created(){
      this.id = this.$route.query.id
      this.getList()
    },
    methods: {
      // 触摸事件处理
      onTouchStart(e) {
        this.startDragging(e.touches[0].clientX);
      },

      onTouchMove(e) {
        this.onDragging(e.touches[0].clientX);
      },

      onTouchEnd() {
        this.endDragging();
      },

      // 鼠标事件处理
      onMouseDown(e) {
        this.startDragging(e.clientX);
        e.preventDefault();
      },

      onMouseMove(e) {
        if (this.isDragging) {
          this.onDragging(e.clientX);
        }
      },

      onMouseUp() {
        this.endDragging();
      },

      onMouseLeave() {
        if (this.isDragging) {
          this.endDragging();
        }
      },

      // 开始拖动
      startDragging(clientX) {
        this.isDragging = true;
        this.startX = clientX;
        this.currentX = clientX;
        this.dragDistance = 0;
      },

      // 拖动中
      onDragging(clientX) {
        if (!this.isDragging) return;

        this.currentX = clientX;
        this.dragDistance = this.startX - this.currentX;
      },

      // 结束拖动
      endDragging() {
        if (!this.isDragging) return;

        this.isDragging = false;

        // 根据滑动距离判断是否切换
        if (Math.abs(this.dragDistance) > this.dragThreshold) {
          if (this.dragDistance > 0) {
            // 向右滑动，显示下一个
            this.nextVocabulary();
          } else {
            // 向左滑动，显示上一个
            this.prevVocabulary();
          }
        }

        // 重置拖动状态
        this.dragDistance = 0;
      },

      // 下一个词汇
      nextVocabulary() {
        if (this.info.vocabularies && this.info.vocabularies.length > 0) {
          const nextIndex = this.currentVocabularyIndex + 1;
          if (nextIndex < this.info.vocabularies.length) {
            this.currentVocabularyIndex = nextIndex;
          }
        }
      },

      // 上一个词汇
      prevVocabulary() {
        if (this.info.vocabularies && this.info.vocabularies.length > 0) {
          const prevIndex = this.currentVocabularyIndex - 1;
          if (prevIndex >= 0) {
            this.currentVocabularyIndex = prevIndex;
          }
        }
      },

      // 跳转到指定词汇
      goToVocabulary(index) {
        this.currentVocabularyIndex = index;
      },

      // 获取词汇文本
      getVocabularyText(index, field) {
        if (this.info.vocabularies && this.info.vocabularies[index]) {
          let text = this.info.vocabularies[index][field];
          return text ? text.replace(/;/g, '') : '';
        }
        return '';
      },

      // 获取词汇音频
      getVocabularyAudio(index) {
        if (this.info.vocabularies && this.info.vocabularies[index]) {
          return this.info.vocabularies[index].vocabulary_audio;
        }
        return '';
      },

      // 切换词汇音频播放/暂停
      toggleVocabularyAudio(index) {
        const audioRef = `audioVocabulary${index}`;

        let audioElement = null;
        if (this.$refs[audioRef]) {
          audioElement = Array.isArray(this.$refs[audioRef])
            ? this.$refs[audioRef][0]
            : this.$refs[audioRef];
        }

        if (audioElement) {
          if (this.activeAudioIndex === index) {
            audioElement.pause();
            this.activeAudioIndex = -1;
          } else {
            this.pauseAllAudios();
            this.activeAudioIndex = index;
            audioElement.currentTime = 0;
            audioElement.play().catch(e => {
              console.log("播放失败:", e);
              this.activeAudioIndex = -1;
            });
          }
        }
      },

      // 音频播放结束
      onAudioEnded(index) {
        if (this.activeAudioIndex === index) {
          this.activeAudioIndex = -1;
        }
      },

      // 格式化示例文本
      formatExampleText(text) {
        if (!text) return '';
        return text;
      },

      // 切换汉字
      switchKanji(id) {
        if (id !== this.info.id) {
          this.$router.push({path:'/KatakanaResult',query: {id: id}});
        }
      },

      // 修复暂停所有音频的方法
      pauseAllAudios() {
        Object.keys(this.$refs).forEach(ref => {
          if (ref.startsWith('audioVocabulary')) {
            let audioElements = this.$refs[ref];
            if (Array.isArray(audioElements)) {
              audioElements.forEach(audio => {
                if (audio && audio.pause) {
                  audio.pause();
                  audio.currentTime = 0;
                }
              });
            } else if (audioElements && audioElements.pause) {
              audioElements.pause();
              audioElements.currentTime = 0;
            }
          }
        });
        this.activeAudioIndex = -1;
      },

      back(){
        this.$router.push({path:'/Katakana'});
      },

      getList(){
        let that = this
        let data = {
          "id": this.id
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/katakana/detail', data, r =>{
          that.$parent.returnCode(r, function(){
            that.$parent.loadModal(false);
            that.info = r.data;
            that.$nextTick(() => {
              that.preloadVideos();
              that.videoElement = that.$refs.videoPlayer;
            });
          })
        })
      },

      // 播放视频
      playVideo(refName, videoType) {
        const videoPlayer = this.$refs[refName];
        if (videoPlayer) {
          videoPlayer.play().then(() => {
            console.log(`${videoType} video started playing`);
          }).catch(error => {
            console.error(`Error playing ${videoType} video:`, error);
          });
        }
      },

      pauseAllVideos() {
        const videoPlayers = [this.$refs.videoPlayer, this.$refs.memoryVideoPlayer];
        videoPlayers.forEach(player => {
          if (player) {
            player.pause();
            player.currentTime = 0;
          }
        });
        this.strokeVideoPlaying = false;
        this.memoryVideoPlaying = false;
      },

      //播放时间统计
      reportWatchTime(force = false, finished = false) {
        return;
        const now = Date.now();
        let currentWatch = (now - this.startTime) / 1000;
        this.totalWatchTime += currentWatch;
        this.startTime = now;
        if (!force && currentWatch < 5) return;
        let that = this
        let ts = Date.now();
        let seconds = Math.round(this.totalWatchTime);
        let sign = that.generateSign(seconds, ts);
        let data = {
          video_id: this.id,
          seconds: seconds,
          finished: finished,
          video_type: 'kanji',
          ts: ts,
          sign: sign
        }
        that.$api.post('/api/watch/report_time', data, r =>{
          that.$parent.returnCode(r, function(){})
        })
      },

      generateSign(score, ts, secret = "jksdfuiAa4so") {
        const str = String(score) + String(ts) + secret
        return md5(str);
      },

      canCountTime() {
        return !document.hidden &&
          !this.videoElement.paused &&
          this.videoElement.playbackRate === 1.0;
      },

      startReporting() {
        this.startTime = Date.now();
        if (this.reportingInterval) clearInterval(this.reportingInterval);

        this.reportingInterval = setInterval(() => {
          if (this.canCountTime()) {
            this.reportWatchTime();
          }
        }, 10000);
      },

      onPlay(videoType) {
        console.log(`${videoType} 开始播放`);
        if (videoType === 'stroke') {
          this.strokeVideoPlaying = true;
          this.videoElement = this.$refs.videoPlayer;
        } else if (videoType === 'memory') {
          this.memoryVideoPlaying = true;
          this.videoElement = this.$refs.memoryVideoPlayer;
        }

        if (!this.videoElement) return;
        if (this.videoElement.playbackRate !== 1.0) {
          this.videoElement.pause();
          return;
        }
        // this.startReporting();
      },

      onPause(videoType) {
        console.log(`${videoType} 暂停播放`);
        if (videoType === 'stroke') {
          this.strokeVideoPlaying = false;
        } else if (videoType === 'memory') {
          this.memoryVideoPlaying = false;
        }

        if (this.canCountTime()) {
          this.reportWatchTime();
        }
        clearInterval(this.reportingInterval);
      },

      onEnded(videoType) {
        console.log(`${videoType} 播放结束`);
        if (videoType === 'stroke') {
          this.strokeVideoPlaying = false;
        } else if (videoType === 'memory') {
          this.memoryVideoPlaying = false;
        }

        this.reportWatchTime(true, true);
        clearInterval(this.reportingInterval);
      },

      onSeeking() {
        console.log('拖动进度条');
        this.startTime = Date.now();
      },

      onRateChange() {
        console.log('倍速播放');
        if (this.videoElement.playbackRate !== 1.0) {
          this.videoElement.pause();
        }
      },

      preloadVideos() {
        const videoPlayers = [this.$refs.videoPlayer, this.$refs.memoryVideoPlayer];
        videoPlayers.forEach(player => {
          if (player) {
            player.preload = "auto";
            player.load();
          }
        });
      },

      onVideoLoaded(videoType) {
        console.log(`${videoType} video loaded`);
      },

      onVideoError(videoType) {
        console.error(`${videoType} video error`);
      },

      handleVisibilityChange() {
        if (document.hidden) {
          this.reportWatchTime(true);
          clearInterval(this.reportingInterval);
        } else if (this.videoElement && !this.videoElement.paused) {
          // this.startReporting();
        }
      },

      handleBeforeUnload() {
        this.reportWatchTime(true);
      },

      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      }
    }
}
</script>

<style scoped>
.detail_inner {
  padding: 20px;
}

.m_tabpne {
  margin-bottom: 20px;
}

.detail_summary {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 300px;
  margin-bottom: 20px;
}

.detail_summary .image {
  text-align: center;
  margin-right: 20px;
}

.detail_summary .image img {
  max-width: 120px;
  height: auto;
}

.detail_summary .image b {
  display: block;
  margin: -5px 0 0;
  font-weight: 400;
}
.detail_order img{width:100%}
.words_inner {
  position: relative;
}

.words_inner button {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;
  transition: transform 0.3s ease;
}

.words_inner button.image-grow {
  transform: scale(1.2);
}

.words_inner button img {
  width: 44px;
  height: 34px;
}

.detail_anime, .detail_memory {
  margin-bottom: 30px;
}

.detail_anime strong, .detail_memory strong, .detail_ex strong {
  display: block;
  margin-bottom: 15px;
  color: #2a2d5a;
}

.anime {
  position: relative;
  border: 2px solid #475063;
  text-align: center;
  background-color: #fff;
}

.anime video {
  width: 100%;
  //max-width: 400px;
  border-radius: 8px;
}

/* 滑动轮播样式 */
.vocab-carousel {
  position: relative;
  margin: 20px 0;
}

.carousel-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 200px;
}

.carousel-arrow {
  background: rgba(42, 45, 90, 0.8);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.carousel-arrow:hover:not(:disabled) {
  background: rgba(42, 45, 90, 1);
  transform: scale(1.1);
}

.carousel-arrow:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.carousel-arrow-prev {
  margin-right: 15px;
}

.carousel-arrow-next {
  margin-left: 15px;
}

.carousel-content {
  flex: 1;
  overflow: hidden;
  position: relative;
  cursor: grab;
  user-select: none;
}

.carousel-content:active {
  cursor: grabbing;
}

.carousel-track {
  display: flex;
  transition: transform 0.3s ease;
  will-change: transform;
}
.vocab-carousel{
  background: #fff;
  border: 2px solid #475063;
  padding:30px;
  }
.carousel-slide {
  flex: 0 0 100%;
  min-width: 100%;
  text-align: center;
  padding: 20px;
  border-radius: 10px;
  box-sizing: border-box;
}

/* 指示器样式 */
.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  gap: 8px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background: #2a2d5a;
  transform: scale(1.2);
}

.indicator:hover {
  background: #666;
}

.detail_ex .ex {
  display: grid;
  gap: 20px;
}

.detail_ex .detail {
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  border-left: 4px solid #2a2d5a;
}

.detail_ex .detail p:first-child {
  margin-bottom: 8px;
}

.detail_ex .detail p:last-child {
  color: #666;
}
.detail_ex .detail p em{color:#eaba74}
.slash {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/page/KatakanaResult.vue